import { render, staticRenderFns } from "./HomePageDesktop.vue?vue&type=template&id=4fc8d808"
import script from "./HomePageDesktop.vue?vue&type=script&lang=js"
export * from "./HomePageDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports